import { useQuery } from '@tanstack/react-query';
import { mobietrainFetch } from './rest';
import { useMobietrainUser } from './useMobietrainUser';

export interface DynamicConfiguration {
  plugins: {
    milestones: boolean;
  };
}

export const useGetDynamicConfigurationQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { data: user } = useMobietrainUser({ enabled });
  const accountId = user?.accountId;

  return useQuery({
    queryKey: ['dynamic-configuration', accountId],
    queryFn: () => mobietrainFetch<DynamicConfiguration>(`/bff/app/configurations/${accountId}`, { method: 'GET' }),
    enabled: enabled && Boolean(accountId),
  });
};
